import { isMobile } from 'react-device-detect'

// Styling for various layout components
const layoutStyle = {
	// height: '100vh',
	// overflow: 'hidden',
	margin: 0
}

const siderStyle = {
	textAlign: 'left',
	color: '#1b1d1f',
	backgroundColor: '#fff',
	borderRight: '1px solid #e8e8e8',
	overflowY: 'auto',
	zIndex: 999,
	padding: isMobile ? '20px' : '0px',
	position: 'sticky',
	height: '100vh',
	top: 0
}

const headerStyle = {
	display: 'flex',
	width: '100%',
	justifyContent: 'space-between',
	background: '#fff',
	padding: isMobile ? '30px' : '30px'
}

const contentStyle = {
	textAlign: 'left',
	minHeight: 120,
	color: '#000',
	backgroundColor: '#fff',
	padding: '0 30px'
	// overflowY: 'scroll'
}

const footerStyle = {
	textAlign: 'center',
	backgroundColor: '#fff',
	color: '#000',
	padding: '30px'
}

export { layoutStyle, siderStyle, headerStyle, contentStyle, footerStyle }
